// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b9016830c9b3103cc69189c98de3f791e17b4a01.chunk.bundle.js";
};